import { render } from "./ConnectSearchConsole.vue?vue&type=template&id=35d43768"
import script from "./ConnectSearchConsole.vue?vue&type=script&lang=js"
export * from "./ConnectSearchConsole.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__